import { Clipboard } from '@angular/cdk/clipboard';

export namespace TextHelper {
  /**
   * For longer text the browser needs time to fill an intermediate textarea element and copy the content.
   * Directly calling copy may fail in this case, so you can pre-load the text by calling beginCopy.
   * @see https://material.angular.io/cdk/clipboard/overview
   * @param text to copy
   * @param toClipboard service
   */
  export const copy = async (text: string, toClipboard: Clipboard) => {
    return new Promise<boolean>(resolve => {
      const pending = toClipboard.beginCopy(text);

      let remainingAttempts = 3;

      const attempt = () => {
        const result = pending.copy();

        if (!result && --remainingAttempts) {
          setTimeout(attempt);
        } else {
          // destroy when we're done
          pending.destroy();
          resolve(result);
        }
      };

      attempt();
    });
  };

  export const stripHtmlTags = (content: string) => {
    const plainText = content.replace(/<[^>]*>/g, '');
    return plainText;
  };

  export const estimateReading = (content: string) => {
    if (!content) return 0;

    const text = stripHtmlTags(content);
    if (!text?.trim()) return 0;

    // see https://irisreading.com/what-is-the-average-reading-speed/#:~:text=Generally%2C%20reading%20at%20less%20than,of%20reading%20and%20your%20comprehension.
    const avgSpeed = 400; // words per minute
    const words = text.split(/\s+/g);
    const estimate = Math.round(words.length / (avgSpeed / 60) * 10) / 10;
    return estimate; // in seconds
  };
};
